import Typography from '~/components/Typography';

interface Props {
  name: string;
}

const PreferenceName = ({ name }: Props) => {
  return (
    <Typography as="p" size="sm" weight="medium" className="text-[#111827]">
      {name}
    </Typography>
  );
};

export default PreferenceName;
